import { WebSocketChannelClient } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/WebSocketChannelClient";

export default new WebSocketChannelClient("notifications");
